import { authPost } from "@api";
import { DEPLOYMENT_URL } from "@constants";

interface RepoSecretResponse {
  token_id: string;
}

export const addDeploymentRepoSecret = (
  deploymentId: string,
  repoFullName: string
): Promise<RepoSecretResponse> => {
  const url = `${DEPLOYMENT_URL}/${deploymentId}/repos/${repoFullName}/_secret`;
  return authPost<{}, RepoSecretResponse>(url, {});
};
